import { createAsyncThunk } from "@reduxjs/toolkit";
import { getGeozoneById } from "domain/geozones/api/get-geozone-by-id";

export const getGeozoneByIdAction = createAsyncThunk(
  "geozones/getGeozoneByIdAction",
  async ({
    accountId,
    geozoneId
  }: {
    accountId: string;
    geozoneId: string;
  }) => {
    try {
      return await getGeozoneById({ accountId, geozoneId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
